import avatarMaya from '../../../assets/tawk-team/tawk-advisor-maya.png';
import avatarPriya from '../../../assets/tawk-team/tawk-advisor-priya.png';
import avatarNoah from '../../../assets/tawk-team/tawk-advisor-noah.png';

export const TAWK_PROPERTY_ID = '6a94f4247e90883445bf0e45';
export const TAWK_WIDGET_ID = '1k1atjcl5';
export const SCRIPT_ID = 'tawk-to-embed';
export const STYLE_ID = 'tawk-theme-sync';
export const EMBED_SRC = `https://embed.tawk.to/${TAWK_PROPERTY_ID}/${TAWK_WIDGET_ID}`;
export const DOCK_PORTAL_ID = 'tawk-dock-portal';

export const COMPACT_MQ = '(max-width: 1024px)';
export const PHONE_MQ = '(max-width: 768px)';
export const TAWK_Z_INDEX = 1050;

export const FALLBACK_THEME = Object.freeze({ primary: '#1a3a4f' });
export const PANEL_HEADER = '#1a3a4f';
export const FRAME_RADIUS = '16px';
export const FRAME_RADIUS_PHONE = '14px';
export const FRAME_HEADER_FILL = '9rem';
export const TEAM_AVATARS = [avatarMaya, avatarPriya, avatarNoah];

export const CHROME_HEADER_ID = 'richuel-tawk-header';
export const CHROME_TEAM_ID = 'richuel-tawk-team';
export const CHROME_BRAND_ID = 'richuel-tawk-brand';
export const CHROME_MINIMIZE_ID = 'richuel-tawk-min';
export const SEND_BTN_CLASS = 'richuel-tawk-send';

export const MINIMIZE_LABEL_RE = /\bminimi[sz]e\b/i;
export const UPLOAD_LABEL_RE = /upload\s*file|attach(?:ment| file)?/i;
export const PHONE_KEY_RE = /\b(phone|mobile|tel)\b/i;
export const PHONE_SUBMIT_BTN_RE = /start\s*(a\s*)?(chat|conversation)|submit|begin|continue/i;

export const PRIMARY_NAV_SEL =
  '.tawk-route-back, .tawk-toolbar-nav[aria-label="primary"], [role="navigation"][aria-label="primary"]';
export const SECONDARY_NAV_SEL =
  '.tawk-toolbar [role="navigation"][aria-label="secondary"], .tawk-toolbar-nav[aria-label="secondary"]';
